import { useEffect } from "react";
import type { PropsWithChildren, ReactNode } from "react";
import { useOnlineStatus } from "providers/OnlineStatusProvider";

function Offline({ children }: Readonly<PropsWithChildren>): ReactNode {
  const { isOnline, checkIfOnline } = useOnlineStatus();

  useEffect(() => {
    void checkIfOnline();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isOnline) return null;
  else return children;
}

export default Offline;
